import { createContext, ReactNode, useMemo } from 'react';
import { ComponentSectionContextType } from '../types/context';

const defaultValues: ComponentSectionContextType = {
  isProvided: false,
  componentSection: 'list',
};

export const ComponentSectionContext =
  createContext<ComponentSectionContextType>(defaultValues);

const ComponentSectionContextProvider = ({
  children,
  componentSection,
}: {
  children: ReactNode;
  componentSection: ComponentSectionContextType['componentSection'];
}) => {
  const value: ComponentSectionContextType = useMemo(
    () => ({
      isProvided: true,
      componentSection,
    }),
    [componentSection]
  );

  return (
    <ComponentSectionContext.Provider value={value}>
      {children}
    </ComponentSectionContext.Provider>
  );
};

export default ComponentSectionContextProvider;
